module.exports = __webpack_public_path__ + "img/cefloreco-banner-1-thumbnail.d0f9954e.webp";